<div class="member-card">
  <!-- Row 1: Avatar and Member Info -->
  <div class="row-1">
    <div class="member-avatar-wrapper">
      <img
        class="member-avatar"
        src="{{ imgSrc }}"
        alt="{{ member.fullName }}"
      />
    </div>
    <div class="member-info">
      <h3 class="member-name">{{ member.fullName }}</h3>
      <div class="member-details">
        <span class="detail-item">Age: {{ member.age }}</span>
        <span class="detail-item">Height: {{ ht }} cm</span>
        <span class="detail-item">Weight: {{ wt }}</span>
        <span class="detail-item">BMI: {{ bmi }}</span>
      </div>
    </div>
  </div>

  <!-- Row 2: Plan Info -->
  <div class="row-2">
    <!-- Plan Status Info -->
    <div class="plan-info" *ngIf="hasExistingPlan">
      <div class="plan-details">
        <div class="detail-group">
          <span class="detail-label">Plan Name</span>
          <span class="detail-value">{{ fitnessPlanName || '---' }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">Active Time</span>
          <span class="detail-value">{{ getActiveDuration() }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">Start Date</span>
          <span class="detail-value">{{ getFormattedStartDate() }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">End Date</span>
          <span class="detail-value">{{ getFormattedEndDate() }}</span>
        </div>
      </div>
    </div>

    <!-- No Plan Info -->
    <div class="no-plan-info" *ngIf="!hasExistingPlan">
      <div class="plan-details">
        <div class="detail-group">
          <span class="detail-label">Plan Name</span>
          <span class="detail-value">{{ fitnessPlanName || '---' }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">Active Time</span>
          <span class="detail-value">{{ getActiveDuration() }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">Start Date</span>
          <span class="detail-value">{{ getFormattedStartDate() }}</span>
        </div>
        <div class="detail-group">
          <span class="detail-label">End Date</span>
          <span class="detail-value">{{ getFormattedEndDate() }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Row 3: Action Buttons -->
  <div class="row-3">
    <div class="action-buttons">
      <!-- Exercise Instructions Button -->
      <a
        class="btn btn-outline-primary exercise-instructions-btn"
        [routerLink]="['/fitness-plan/exercise-instructions']"
        [queryParams]="{ memberId: member.id, memberName: member.fullName }"
        title="Manage custom instructions for exercises"
      >
        <span class="btn-icon">📝</span>
        Instructions
      </a>

      <!-- Temporarily hidden - View Logs button
      <a
        class="btn btn-secondary"
        [routerLink]="['/fitness-plan-logs']"
        [queryParams]="{ memberId: member.id }"
        *ngIf="hasExistingPlan"
      >
        View Logs
      </a>
      -->
      <a
        class="btn btn-primary"
        [routerLink]="['/create-fitness-plan']"
        [queryParams]="{ memberId: member.id }"
        [state]="{ memberData: getMemberDataForNavigation() }"
      >
        Add Fitness Plan
      </a>
    </div>
  </div>
</div>
